import amplitude from './amplitude'
import * as experiments from 'packages/experiments'

if (module.hot) {
  module.hot.accept()
}

;(function () {
  const { pathname } = window.location

  experiments.initABTests(amplitude)

  if (pathname === '/' || pathname.includes('javascript-online')) {
    amplitude.track('landing:js:loaded')
  } else if (pathname.includes('typescript-playground')) {
    amplitude.track('landing:ts:loaded')
  } else if (pathname.includes('javascript-editor')) {
    amplitude.track('landing:js-editor:loaded')
  } else if (pathname.includes('online-javascript-compiler')) {
    amplitude.track('landing:js-compiler:loaded')
  }
})()
